<app-kin-training-navbar></app-kin-training-navbar>
<router-outlet></router-outlet>
